import { createApp } from 'vue';
import { ConvertMyFormApplication } from './application';

export class ConvertMyForm{
    async init(store){
        const app = createApp(ConvertMyFormApplication);
        app.use(store);

        app.mount('.convert-my-form');
    }
}


